// Valores de fábrica de la configuración de la portada. Antes estaban dos veces en App.tsx
// (frontpageConfig y customizeForm, P-19); ahora hay una sola constante.
// La web pública los usa hasta que llega GET /api/frontpage/config.
export const DEFAULT_FRONTPAGE = {
  topBannerHeight: 90,
  topBannerImage: "",
  topBannerMobileImage: "",
  topBannerBgColor: "#0f172a",
  topBannerText: "Farmacias de Turno en Tandil",
  topBannerLink: "",
  hideTopBannerMobile: false,
  hideTopBannerDesktop: false,
  locationBoxPosition: "above",
  bottomBannerHeight: 170,
  bottomBannerImage: "",
  bottomBannerMobileImage: "",
  bottomBannerBgColor: "#1e293b",
  bottomBannerText: "",
  bottomBannerLink: "",
  detailsBoxColor: "#10b981",
  showWhatsAppBanner: false,
  whatsAppBannerPosition: "top",
  whatsAppBannerText:
    "📲 Consulta quién está de guardia hoy o mañana cómodamente por WhatsApp.",
  whatsAppConsultPhone: "",
  whatsAppConsultDefaultText: "Hoy",
  showWhatsAppFloatingButton: false,
  pharmacyFontSize: "sm",
  pharmacyFontWeight: "extrabold",
  pharmacyFontColor: "white",
  pharmaciesPerRow: 2,
  carouselDesktop: false,
  addressFontSize: "sm",
  addressFontWeight: "semibold",
  addressFontColor: "white",
  phoneFontSize: "sm",
  phoneFontWeight: "semibold",
  phoneFontColor: "white",
  showPhotoOnMobile: true,
  hideCountdownFrame: false,
  countdownBelowToggle: false,
  footerLogoUrl: "",
  footerAddress: "",
  footerPhone: "",
  footerEmail: "",
  footerSocialsText: "Seguinos en redes sociales",
  footerFacebookUrl: "",
  footerInstagramUrl: "",
  footerBgColor: "#1e293b",
  footerCopyrightText: "© 2026 FarmaTurno Tandil - Todos los derechos reservados.",
  footerCopyrightLink: "",
  promoModuleEnabled: false,
  promoModulePosition: "above_location",
  promoModuleImage: "",
  promoModuleDesktopImage: "",
  promoModuleLink: "",
  promoModuleAlt: "Módulo publicitario",
  googleAnalyticsId: "",
  adminEmail: "",
  googleClientId: "",
};

export type FrontpageForm = typeof DEFAULT_FRONTPAGE;

/** Los guarda Configuración → Accesos (Ficha 8); la portada no los manda. */
export const ACCESOS_KEYS = ["adminEmail", "googleAnalyticsId", "googleClientId"] as const;

export type PortadaForm = Omit<FrontpageForm, (typeof ACCESOS_KEYS)[number]>;

/** Todo lo que guarda Configuración → Portada del sitio. */
export const PORTADA_KEYS = (Object.keys(DEFAULT_FRONTPAGE) as Array<keyof FrontpageForm>).filter(
  (key) => !(ACCESOS_KEYS as readonly string[]).includes(key),
) as Array<keyof PortadaForm>;
